/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListReportDefinitionQueryResponse, AuditReportsListReportDefinitionQueryParams, AuditReportsListReportDefinition401, AuditReportsListReportDefinition403 } from "../models/AuditReportsListReportDefinition";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsListReportDefinition } from "../axios/auditReportsListReportDefinition";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsListReportDefinitionQueryKey = (params: AuditReportsListReportDefinitionQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/report-definitions' }, ...(params ? [params] : [])] as const

export type AuditReportsListReportDefinitionQueryKey = ReturnType<typeof auditReportsListReportDefinitionQueryKey>

export function auditReportsListReportDefinitionQueryOptions(params?: AuditReportsListReportDefinitionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsListReportDefinitionQueryKey(params)
        return queryOptions<AuditReportsListReportDefinitionQueryResponse, ResponseErrorConfig<AuditReportsListReportDefinition401 | AuditReportsListReportDefinition403>, AuditReportsListReportDefinitionQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsListReportDefinition(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all report definitions for the client, optionally filtered by report type
 * @summary List all report definitions
 * {@link /audit-reports/v1/report-definitions}
 */
export function useAuditReportsListReportDefinition<TData = AuditReportsListReportDefinitionQueryResponse, TQueryData = AuditReportsListReportDefinitionQueryResponse, TQueryKey extends QueryKey = AuditReportsListReportDefinitionQueryKey>(params?: AuditReportsListReportDefinitionQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsListReportDefinitionQueryResponse, ResponseErrorConfig<AuditReportsListReportDefinition401 | AuditReportsListReportDefinition403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsListReportDefinitionQueryKey(params)
         

         const query = useQuery({
          ...auditReportsListReportDefinitionQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsListReportDefinition401 | AuditReportsListReportDefinition403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}